import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { UserRule } from '@verify/shared-components/models';
import { AuthService } from '@verify/shared-components/services';
import { map, take } from 'rxjs';
import { CollectionService } from '../services/asset/collection.service';

export const collectionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const authService: AuthService = inject(AuthService);
  const collectionService: CollectionService = inject(CollectionService);
  const router: Router = inject(Router);

  const collectionId = route.params['collectionId'];
  if (collectionId) {
    return collectionService.getCollection(collectionId).pipe(
      take(1),
      map((collection) => {
        if (!collection || collection.deleted) {
          return router.parseUrl('error?code=404');
        } else {
          const { id, rules, groupIds } = authService.currentUser;
          const isProjectAdmin = rules.includes(UserRule.projectAdmin);
          if (
            isProjectAdmin ||
            collection.createdBy === id ||
            collection.groupIds.some((gid) => groupIds.includes(gid))
          ) {
            return true;
          } else {
            return router.parseUrl('error?code=403');
          }
        }
      }),
    );
  }
  return router.parseUrl('error?code=404');
};
